<form [formGroup]="searchFilterForm">
    <!--Searchbar-->
    <div class="row">
        <div class="col-12">
            <div class="d-flex mb-2 px-1">
                <input formControlName="searchFilterField" class="form-control bar" type="search" placeholder="Cerca..."
                    aria-label="Search">
                <button type="submit" (click)="clickSearch()" class="bordersearch"><i
                        class="far fa-search grey mx-2"></i></button>
            </div>
        </div>
    </div>

    <!-- Filters -->
    <div class="row">
        <div class="col-lg-10 col-md-12 col-sm-12 col-xs-12">

            <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 p-1 inlineflex-md">
                <div class="form-check pl-0 mx-1 form-check-inline">
                    <label class="form-check-label text fw-normal size16">
                        Data prenotazione:
                    </label>
                </div>
                <input formControlName="searchFilterField_reserved" (change)="filterReserved()" type="date"
                    class="form-date-fw mr-1">
            </div>

            <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 p-1 inlineflex-md">
                <div class="form-check pl-0 mx-1 form-check-inline">
                    <label class="form-check-label text fw-normal size16">
                        Data ritiro:
                    </label>
                </div>
                <input formControlName="searchFilterField_completed" (change)="filterCompleted()" type="date"
                    class="form-date-fw mr-1">
            </div>

            <div class="col-12 align-items-center">
                <div class="form-check mx-1 pb-3 form-check-inline mr-6">
                    <input value="searchFilterField_reservedCheck" name="checkboxFilter" class="form-check-input checkboxes"
                        (change)="toggleCheckBoxes('searchFilterField_reservedCheck')" type="checkbox"
                        id="reservedCheckbox">
                    <label class="form-check-label text fw-normal size16 mr-1" for="reservedCheckbox">
                        Confermato
                    </label>
                </div>
                <div class="form-check pb-3 form-check-inline mr-1 mr-6">
                    <input value="searchFilterField_completedCheck" name="checkboxFilter"
                        class="form-check-input checkboxes" (change)="toggleCheckBoxes('searchFilterField_completedCheck')"
                        type="checkbox" id="completedCheckbox">
                    <label class="form-check-label text fw-normal size16" for="completedCheckbox">
                        Completato
                    </label>
                </div>
                <div class="form-check mx-1 pb-3 form-check-inline mr-6">
                    <input value="searchFilterField_pendingCheck" name="checkboxFilter" class="form-check-input checkboxes"
                        (change)="toggleCheckBoxes('searchFilterField_pendingCheck')" type="checkbox">
                    <label class="form-check-label text fw-normal size16 mr-1">
                        Pending
                    </label>
                </div>
    
                <div class="form-check pb-3 form-check-inline mr-1 mr-6">
                    <input value="searchFilterField_cancelledCheck" name="checkboxFilter"
                        class="form-check-input checkboxes" (change)="toggleCheckBoxes('searchFilterField_cancelledCheck')"
                        type="checkbox">
                    <label class="form-check-label text fw-normal size16">
                        Annullato
                    </label>
                </div>
            </div>
            
            
        </div>
        <div class="col-lg-2 col-md-12 col-sm-12 col-xs-12 text fw-normal size16 txt-remove">
            <span class="clickable" (click)="clickButtonClearFilter()"> Rimuovi filtri</span>
        </div>
        
        <!-- Riga selezioni -->
        <div class="col-lg-10 col-md-10 hidden-sm hidden-xs"></div>
        <div class="col-lg-2 col-md-2 text fw-normal size15 txt-remove clickable" (click)="goToCalendar()">
            Calendario
        </div>
    </div>
</form>

<!-- Table -->
<div class="w-100" [ngClass]="!isEmpty  ? 'table-responsive-sm blocks': 'not_visible'">
    <table aria-describedby="" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-striped" style="width: 100%;">
        <thead>
            <tr class="back-white fw-bold">
                <th class="pb-4 border-bottom-0" scope="col">Data di prenotazione</th>         
                <th class="pb-4 border-bottom-0" scope="col">Data appuntamento</th>
                <th class="pb-4 border-bottom-0" scope="col">Store COMSY</th>
                <th class="pb-4 border-bottom-0" scope="col">Città store</th>
                <th class="pb-4 border-bottom-0" scope="col">Indirizzo</th>
                <th class="pb-4 border-bottom-0" scope="col">Status</th>
                <th class="pb-4 border-bottom-0" scope="col"></th>
            </tr>
        </thead>
        <tbody [hidden]="isSearching">
            <tr class="table-font" *ngFor="let sim of entityList">
                <td>{{sim.reservationDate}}</td>
                <td>{{sim.appointmentDate}}</td>
                <td>{{sim.storeComsy}}</td>
                <td>{{sim.city}}</td>
                <td>{{sim.address}}</td>
                <td>{{sim.appointmentStatus}}</td>
                <td>
                    <div class="flex">
                        <a class="pr-5 btn btn-lg"><i (click)="clickButtonUpdate(sim.id)"
                                class="far fa-pencil ora clickable"></i></a>
                    </div>
                </td>
            </tr>
        </tbody>
        <tfoot [hidden]="!isSearching">
            <tr>
                <td colspan="7">
                    <app-spinner-table [visible]="isSearching"></app-spinner-table>                 
                </td>
            </tr>
        </tfoot>
    </table>
</div>
<div *ngIf="isEmpty" class="table-responsive-sm blocks no-data w-100">
    <div class="result-message">
        <span class="message-font">La ricerca non ha prodotto risultati!</span>
    </div>
</div>
